import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";
import './contactcontent.css';

const ContactContent: React.FC = () => {

  emailjs.init({
    publicKey: 'IV3Wb90BWtnqMahAu',
    blockHeadless: true,
    limitRate: {
      throttle: 10000, // 10s
    },
  });
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);

  const handleSubmit = async(e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    const serviceId = 'service_44upcir';
    const templateId = 'template_par06wg';
    try {

      if (!captchaToken) {
        alert("Please complete the reCAPTCHA.");
        return;
      }

      await emailjs.send(serviceId, templateId, {
        from_name: name,
        from_email: email,
        message: message
      });
    } catch (error) {
      console.log(error);
      alert("An error occured, please try again or send an email directly to info@alverosoftware.com")
    } finally {
      alert("Message sent!");
      setName('');
      setEmail('');
      setMessage('');
    }
  };

  return (
    <main>
      <header>
        <h1>Contact Us</h1>
      </header>
      <div>
        <section className="contact-info">
          <h2>Get in Touch</h2>
          <p>If you have any questions or would like to discuss a project, please feel free to reach out to us using the contact form below, or via the contact details provided.</p>
        </section>

        <section className="contact-details">
          <h3>Contact Information</h3>
          <p><strong>Phone:</strong> (312) 857-5896</p>
          <p><strong>Email:</strong> info@alverosoftware.com</p>
        </section>

        <section className="contact-form">
          <h3>Contact Form</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message:</label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>
            </div>
            <ReCAPTCHA
              sitekey="6Lfn_UUrAAAAAB7J8wYA38AwuMaxvtfuL2fkYvAG"
              onChange={token => setCaptchaToken(token)}
            />
            <button type="submit">Send Message</button>
          </form>
        </section>
      </div>
    </main>
  );
};

export default ContactContent;
